module.exports = __webpack_public_path__ + "static/media/Logo-1.c13e3112.png";